export const AUTOMOTIVE = [
  {
    item: 'Tesoro',
    itemImageDesktop: '/images/packaging/customizedPorject/automotive/desktop/tesoro.webp',
    //itemImageMobile: '/images/packaging/customizedPorject/automotive/mobile/tesoro.webp',
    path: '/packaging/customized-projects/automotive/tesoro',
  },
  {
    item: 'Zucchero',
    itemImageDesktop: '/images/packaging/customizedPorject/automotive/desktop/zucchero.webp',
    //itemImageMobile: '/images/packaging/customizedPorject/automotive/mobile/zucchero.webp',
    path: '/packaging/customized-projects/automotive/zucchero',
  },
]